module.exports = __webpack_public_path__ + "img/length_1.8e080153.png";